var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10C20.5 10.0352 20.5 10.0703 20.5 10.1055C20.4844 11.5312 19.1875 12.5 17.7617 12.5H13.9375C12.9023 12.5 12.0625 13.3398 12.0625 14.375C12.0625 14.5078 12.0781 14.6367 12.1016 14.7617C12.1836 15.1602 12.3555 15.543 12.5234 15.9297C12.7617 16.4688 12.9961 17.0039 12.9961 17.5703C12.9961 18.8125 12.1523 19.9414 10.9102 19.9922C10.7734 19.9961 10.6367 20 10.4961 20C4.97656 20 0.5 15.5234 0.5 10C0.5 4.47656 4.97656 0 10.5 0C16.0234 0 20.5 4.47656 20.5 10ZM5.5 11.25C5.5 10.5586 4.94141 10 4.25 10C3.55859 10 3 10.5586 3 11.25C3 11.9414 3.55859 12.5 4.25 12.5C4.94141 12.5 5.5 11.9414 5.5 11.25ZM5.5 7.5C6.19141 7.5 6.75 6.94141 6.75 6.25C6.75 5.55859 6.19141 5 5.5 5C4.80859 5 4.25 5.55859 4.25 6.25C4.25 6.94141 4.80859 7.5 5.5 7.5ZM11.75 3.75C11.75 3.05859 11.1914 2.5 10.5 2.5C9.80859 2.5 9.25 3.05859 9.25 3.75C9.25 4.44141 9.80859 5 10.5 5C11.1914 5 11.75 4.44141 11.75 3.75ZM15.5 7.5C16.1914 7.5 16.75 6.94141 16.75 6.25C16.75 5.55859 16.1914 5 15.5 5C14.8086 5 14.25 5.55859 14.25 6.25C14.25 6.94141 14.8086 7.5 15.5 7.5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor);
export default __webpack_public_path__ + "static/media/icon-color.9b33d7b75d5bdc96993c18290bf044c6.svg";
export { ForwardRef as ReactComponent };